// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
function UserResetPasswordDialog(tabPage, parent) {
    var self = this;
    self.TabPage = tabPage;
    self.parent = parent;
    self.Password = ko.observable();
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("500px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    self.Password(self.DialogViewModel.Password1());
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Focus = function () { };
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.Password1 = ko.observable();
    self.DialogViewModel.Password2 = ko.observable();
    var passwordMismatchMessage = Bao.Session.GetMessage("msgResetPasswordMismatch");
    var passwordInvalid = Bao.Session.GetMessage("msgInvalidPassword");
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.Password1() != self.DialogViewModel.Password2()) {
            isComplete = false;
            new BaoDialogViewModel(Bao.Session.ApplicationName, passwordMismatchMessage, "info");
        }
        if (isComplete == true) {
            if (self.ValidatePassword() == false) {
                isComplete = false;
                new BaoDialogViewModel(Bao.Session.ApplicationName, passwordInvalid, "info");
            }
        }
        return isComplete;
    };
    self.ValidatePassword = function () {
        var result = false;
        jQuery.ajax({
            type: "POST",
            url: (window.absolutePath || "") + "Uadm/User/ValidateUserPassword",
            data: JSON.stringify({
                userId: self.parent.UserId(),
                userName: self.parent.Username(),
                password: self.DialogViewModel.Password1()
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (value) {
                result = value.Result;
            },
            error: function () {
                result = false;
            },
            async: false
        });
        return result;
    };
    self.Show = function () {
        tabPage.IsLoading(true);
        Bao.post("Uadm/User/ShowUserResetPasswordDialog", JSON.stringify({}), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            self.DialogViewModel.Focus();
            tabPage.IsLoading(false);
        });
    };
}
export default UserResetPasswordDialog;